<template>
  <vue-modal :key="refreshModal" ref="metric-group-order" name="metric-group-order" :width="400" :height="'auto'" :minHeight="400" :maxHeight="500">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title suggestions-popup-header">{{ title }}</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div v-show="displayResults" class="container">
            <div v-if="modalReturnMessage != ''">
              <span class="text-left text-success">{{ modalReturnMessage }}</span>
            </div>
        </div>
        <div class="data-container metric-group-order">
            <VueDraggable
                v-model="sortedMetricGroups"
                class="list-group draggable-container"
                ghost-class="draggable-ghost"
                :move="checkMove"
                @start="dragging = true"
                @end="endOfDragMetricGroups"
                options="people"
            >
                <div v-show="driver.name != ''" class="list-group-item draggable-card w-100" v-for="driver in this.sortedMetricGroups" 
                    :key="driver.metricGroupId" 
                    :index="driver.metricGroupId">
                    <i class="fa fa-caret-right" aria-hidden="true"></i>
                    <span class="pl-1">{{ driver.name }}</span><span class="pl-2">(Metric Group Id: {{ driver.metricGroupId }})</span>
                </div>
            </VueDraggable>
        </div>
      </div>
      <div class="modal-footer">
        <div class="suggestions-popup-buttons float-right mr-2">
          <button type="button" class="btn btn-primary mr-4" @click="saveMetricGroupSequence">Save Sequence</button>
          <button type="button" class="btn btn-primary ml-2 float-right ml-2 mr-2" @click="closeModal">Close</button>
        </div>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import AdminService from "../services/admin.service";
import MetricsService from "../services/metrics.service";
import ViewMixins from "../mixins/ViewMixins.vue";
import GlobalMixins from "../mixins/GlobalMixins";
import { VueDraggable } from 'vue-draggable-plus';

export default {
  name: "MetricGroupOrder",
  mixins: [ViewMixins, GlobalMixins],
  components: {VueDraggable},
  methods: {
    checkMove: function(e) {},
    loadData() {
        this.sortedMetricGroups = [...this.metricGroups] // clone & don't mutate original             
                                .sort((a, b) => a.sequenceNumber - b.sequenceNumber);
    },
    closeModal() {
      if(this.$refs[this.modalName] != null) {
        this.$refs[this.modalName].visible = false;
      }
      this.refreshModal = !this.refreshModal;
      this.$router.go(0);
    },
    endOfDragMetricGroups: async function(event) {
        let oldIndex = event.oldIndex;
        let newIndex = event.newIndex;
        this.dragging = false;
        if (typeof this.sortedMetricGroups[oldIndex] != "undefined" &&
            typeof this.sortedMetricGroups[newIndex] != "undefined" ){
            this.sortedMetricGroups[newIndex].sequenceNumber = newIndex;
            this.sortedMetricGroups[oldIndex].sequenceNumber = oldIndex;
            for (let index = 0; index < this.sortedMetricGroups.length; index++) {
                this.sortedMetricGroups[index].sequenceNumber = index + 1;
            }
        }
    },
    saveMetricGroupSequenceCallback(response) {
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.modalReturnMessage = response.data.message;
        let vm = this;
        setTimeout(() => {
            vm.displayResults = true;
        }, 500);        
        
      } else {
        AdminService.displayErrorMessage({ text: response.data.message });
      }
    },
    async saveMetricGroupSequence() {
        this.$root.processServerRequest();
        MetricsService.saveMetricGroupSequence(JSON.parse(JSON.stringify(this.sortedMetricGroups)),this.saveMetricGroupSequenceCallback,this);
    },
  },
  props: {},
  data() {
    return {
      refreshModal: true,
      title: "Metric Groups Re-Ordering",
      sortedMetricGroups: [],
      metricGroups: [],
      dragging: false,
      displayResults: false,
      modalReturnMessage: ""
    }
  },
  computed: {},
  mounted() {}
};
</script>
